// extracted by mini-css-extract-plugin
module.exports = {"root":"section-item_root__1s3Re","label":"section-item_label__2Ek_2","value":"section-item_value__14zT-","vertical":"section-item_vertical__1iTMa"};